import { type SkillScope } from '~/hooks/queries/skills/usePrivateSkillsList';

/**
 * Shared React Query cache with `@air/feature-ag-ui-chat` `getSkillsKey` — parity in `skillsQueryKey.unit.test.ts`.
 * TODO(ENG-609): https://linear.app/air/issue/ENG-609/create-shared-package-with-react-query-hooks — dedupe via shared react-query hooks.
 */
export const SKILLS_KEY = 'SKILLS';

export type SkillsQueryKey = [typeof SKILLS_KEY, string, { scope?: SkillScope; type: 'canvas' }];

export const getSkillsQueryKey = (workspaceId: string, scope?: SkillScope): SkillsQueryKey => [
  SKILLS_KEY,
  workspaceId,
  { scope, type: 'canvas' },
];
